import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "locale-loading-overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "spinner-fade" }, {
            default: _withCtx(() => [
                (_ctx.visible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("div", { class: "spinner-container" }, [
                                _createElementVNode("div", { class: "spinner-ring" })
                            ], -1)
                        ]))]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
